import { render, staticRenderFns } from "./formInspeccion.vue?vue&type=template&id=480c588e&scoped=true"
import script from "./formInspeccion.vue?vue&type=script&lang=js"
export * from "./formInspeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c588e",
  null
  
)

export default component.exports